import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { users } from '../../config/api-routes';
import { FiSearch } from 'react-icons/fi';
import { FaUsers } from 'react-icons/fa';
import UserProfile from '../../components/Community/UserProfile';

function Community() {
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState({
        total: 0,
        page: 1,
    });
    const [text, setText] = useState('');

    const fetchUsers = useCallback(async () => {
        try {
            const { data } = await axios.get(`${users}?page=${pagination.page}&search=${text}`);
            setData(data.users);
            setPagination({
                total: data.total,
                page: data.page,
            });
        } catch (error) {
            swal('Failed', error.response.data.message, 'error');
        }
    }, [pagination.page, text]);
    

    useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);

    return (
        <div className='container m-4 pe-5 mt-4'>
            <div className=''>
                <h2 className='fw-bold'>Members <FaUsers className='text-primary' size={25}/></h2>
                <p className='text-secondary'> Meet the team behind the community! </p>
            </div>
            <div className='row mb-3'>                
                
                <div className='col-8 m-4 px-5 mx-5'>
                    <div className='input-group'>
                        <span className='input-group-text'><FiSearch/></span>
                        <input 
                            type='text' 
                            className='form-control search' 
                            placeholder='Search by name or email' 
                            onChange={e => setText(e.target.value)}
                        />
                    </div>
                </div>
            </div>
            {data.length ? (
                <div className='row mx-5'>
                    {data.map((each) => (
                        <div className='col-sm-12 col-md-4 mb-3' key={each._id}>
                            <div className='card shadow-lg'>
                                <div className='card-body'>
                                    <UserProfile data={each} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ): 'No members to show'}
        </div>
    );
}

export default Community;